import { template } from '../../lib/template';

import styles from './styles.module.scss';

export const ToastWithIcon = ({ message, variables }) => {
  const content = variables ? template(message, variables) : message;

  return (
    <div className={styles.container}>
      <div className={styles.icon}>i</div>
      <div className={styles.message}>{content}</div>
    </div>
  );
};
